/* eslint-disable @angular-eslint/directive-selector, @angular-eslint/directive-class-suffix */

import { computed, Directive, input } from '@angular/core';
import { SingleRenderInSourceDirectiveBase } from 'common-ui';
import { ItemStockLayout } from './item-stock-layout';

@Directive({
  selector: '[renderInItemStock]',
  standalone: true,
})
export class RenderInItemStockDirective extends SingleRenderInSourceDirectiveBase {
  public override priority = input<number>(0, { alias: 'renderInItemStockPriority' });
  protected override readonly renderIn = computed(() => ItemStockLayout.Slots.Display);
}
